<template>
    <v-card-text v-for="type in configTypes">
        <experiment-relationship-config-list
            :type="type"
            :experiment-relationship-configs="getExperimentRelationshipConfigsForType(type)"
            :show-inheritance-from-schema-config="showInheritanceFromSchemaConfig"
            @save-experiment-relationship-config="saveExperimentRelationshipConfig"
            @deleted-experiment-relationship-config="deletedExperimentRelationshipConfig"
        />
    </v-card-text>

</template>
<script setup lang="ts">

import { computed } from "vue";
import {
    DEFAULT_EXPERIMENT_SETUP_CONFIG_TYPES,
    ExperimentSetupRelationshipConfig,
    ManageExperimentSetupRelationshipConfigDTO, RelationshipConfigsForType,
    SavedExperimentSetupRelationshipConfig,
} from "@/services/experimentRelationships/models";
import ExperimentRelationshipConfigList
    from "@/components/ExperimentRelationshipConfigs/ExperimentRelationshipConfigList.vue";
import _ from "lodash";

const { experimentRelationshipConfigs, showInheritanceFromSchemaConfig } = defineProps<{
    experimentRelationshipConfigs: RelationshipConfigsForType<ManageExperimentSetupRelationshipConfigDTO>[];
    showInheritanceFromSchemaConfig?: boolean;
}>();

const emit = defineEmits<{
    (e: "saveExperimentRelationshipConfig", experimentRelationshipConfig: ExperimentSetupRelationshipConfig | SavedExperimentSetupRelationshipConfig): void;
    (e: "deletedExperimentRelationshipConfig", experimentRelationshipConfig: SavedExperimentSetupRelationshipConfig): void;
}>();

function saveExperimentRelationshipConfig(config: ExperimentSetupRelationshipConfig | SavedExperimentSetupRelationshipConfig) {
    emit("saveExperimentRelationshipConfig", config);
}

function deletedExperimentRelationshipConfig(config: SavedExperimentSetupRelationshipConfig) {
    emit("deletedExperimentRelationshipConfig", config);
}

const configTypes = computed(() => {
    const types: string[]  = [];

    if (experimentRelationshipConfigs.length > 0) {
        for (const config of experimentRelationshipConfigs) {
            types.push(config.type);
        }
    }
    return _.union(DEFAULT_EXPERIMENT_SETUP_CONFIG_TYPES, types);
})

function getExperimentRelationshipConfigsForType(type: string): ManageExperimentSetupRelationshipConfigDTO[] {
    if (experimentRelationshipConfigs) {
        const forType = experimentRelationshipConfigs.find((config) => config.type === type);
        if (forType) {
            return forType.relationshipConfigs;
        }
    }
    return [];
}

</script>
